import { z } from 'zod';

import { PlaceAnatomySchema } from '../organizations/provision-organization.schemas.js';

/** Fiscal regimes for place bootstrap (BR-PLT-32) — excludes MEI/OTHER. */
export const PlaceTaxRegimeSchema = z.enum(['SIMPLES_NACIONAL', 'LUCRO_PRESUMIDO', 'LUCRO_REAL']);

export type PlaceTaxRegime = z.infer<typeof PlaceTaxRegimeSchema>;

export const ProvisionPlaceBodySchema = z.object({
  name: z.string().min(1),
  slug: z
    .string()
    .min(2)
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
  anatomy: PlaceAnatomySchema,
  /** Required for fiscal corridor bootstrap (BR-PLT-32 / BR-FIS-131). */
  taxRegime: PlaceTaxRegimeSchema,
  /** Optional source place in the same org — snapshot copy of sectors/workbays/storages/enablement (BR-PLT-11). */
  sourcePlaceId: z.uuid().optional(),
});

export type ProvisionPlaceBody = z.infer<typeof ProvisionPlaceBodySchema>;

export const ProvisionPlaceResponseSchema = z.object({
  placeId: z.uuid(),
  organizationId: z.uuid(),
  slug: z.string(),
});

export type ProvisionPlaceResponse = z.infer<typeof ProvisionPlaceResponseSchema>;
